import React, { createContext, useState, useEffect } from 'react';
import { FetchTranslations } from '../../services/api';

export const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
    const [language, setLanguage] = useState('en'); // Default to English
    const [translations, setTranslations] = useState({});
    const [isRTL, setIsRTL] = useState(false);
   
    // Fetch translations from the backend
    const fetchTranslations = async (lang) => {
        try {
            const response = await FetchTranslations(lang);
            const data = await response.data;
            setTranslations(data.reduce((acc, { key, value }) => ({ ...acc, [key]: value }), {}));
            setIsRTL(lang === 'ar'); // Set RTL for Arabic
           
        } catch (error) {
            console.error('Failed to fetch translations:', error);
        }
    };

    // Load translations when the language changes
    useEffect(() => {
        fetchTranslations(localStorage.getItem("lang")==="ar"?"ar":"en");
    }, [language]);

    return (
        <TranslationContext.Provider value={{ translations, language, setLanguage, isRTL }}>
            {children}
        </TranslationContext.Provider>
    );
};
